import { FORMIK_EMPTY_VALUE } from '../../../../../constants/validation'

export const LOGIN_FORM_PHONE_NUMBER_FIELD_NAME_PHONE = 'number'

export const LOGIN_FORM_PHONE_NUMBER_INITIAL_VALUES = {
  [LOGIN_FORM_PHONE_NUMBER_FIELD_NAME_PHONE]: FORMIK_EMPTY_VALUE,
}

export const LOGIN_FORM_PHONE_NUMBER_MAX_LENGTH_PHONE = 15
